module.exports = __webpack_public_path__ + "static/img/mypic.6171155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mypic.jpg
// module id = ALsK
// module chunks = 0